import { GridCellProps } from '@progress/kendo-react-grid';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';

const ViewInvoicesDocTotal = (props: GridCellProps) => {
  const { displayValue } = useGridCellDisplayValue(props);
  return (
    <GridCellBase {...props}>
      <div className="text-right">{displayValue}</div>
    </GridCellBase>
  );
};

export default ViewInvoicesDocTotal;
